import classNames from "classnames";
import { FC } from "react";

import { Typography } from "@/shared/ui";

import styles from "./tag.module.scss";
import { TagProps } from "./tag.types";

const Tag: FC<TagProps> = ({ label, variant, className }) => {
  return (
    <div className={classNames(styles.tag, styles[variant], className)}>
      <Typography variant="caption-1">{label}</Typography>
    </div>
  );
};

export { Tag };
